import axios from 'axios';

export default {
  selectors: (params = {}, config = {}) => axios.get('reports/invoices/selectors', { params, ...config }),
  metrics: (params = {}, config = {}) => axios.get('reports/invoices/metrics', { params, ...config }),
  table: (params = {}, config = {}) => axios.get('reports/invoices/table', { params, ...config }),
  detail: (params = {}, config = {}) => axios.get('reports/invoices/detail', { params, ...config }),
  excel: (params = {}, config = {}) => axios.get('reports/invoices/excel', {
    params,
    responseType: 'blob',
    ...config,
  }),
  pdf: (params = {}, config = {}) => axios.get('reports/invoices/pdf', {
    params,
    responseType: 'blob',
    ...config,
  }),
};
